var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('youtube',{ref:"youtube",staticClass:"pb-1 pt-2",attrs:{"video-id":_vm.src,"width":"100%","height":"240"},on:{"click":_vm.playVideo}})}
var staticRenderFns = []

export { render, staticRenderFns }